<template>
  <div class="your-password">
    <tutorial-modal ref="tutorialModal" :skip="skip" />
    <scan-to-download-modal ref="scanToDownloadModal" />
    <ipad-modal ref="ipadModal" />
    <by-json-page-title />
    <div class="wrap">
      <div class="page-container">
        <div v-show="!byJson && !byMnemonic" class="nav-tab-user-input-box">
          <b-tabs class="x100">
            <div v-if="showProgressBar && false" class="progress-bar" />
            <b-tab
              :title="$t('createWallet.keystore.title-tab')"
              @click="showProgressBar = true"
            >
              <div class="tab-content-block">
                <div class="title-block">
                  <div class="title-popover">
                    <h3>{{ $t('common.password.your') }}</h3>
                    <popover :popcontent="$t('popover.password')" />
                  </div>
                </div>
                <create-wallet-input
                  v-model="password"
                  :switcher="switcher"
                  :param="'Json'"
                />
                <create-wallet-input-footer />
              </div>
            </b-tab>
            <b-tab
              :title="$t('createWallet.mnemonic.title-tab')"
              @click="showProgressBar = true"
            >
              <div class="tab-content-block">
                <div class="title-block">
                  <div class="title-popover">
                    <h3>{{ $t('createWallet.mnemonic.title') }}</h3>
                    <popover
                      :popcontent="$t('createWallet.mnemonic.popover')"
                    />
                  </div>
                </div>
                <by-mnemonic-container />
              </div>
            </b-tab>
          </b-tabs>
        </div>
        <by-json-file-container
          v-if="byJson && !byMnemonic"
          :password="password"
        />
        <by-mnemonic-container v-if="!byJson && byMnemonic" />
      </div>
    </div>
    <by-json-page-footer />
  </div>
</template>

<script>
import ByJsonFileContainer from './containers/ByJsonFileContainer';
import ByMnemonicContainer from './containers/ByMnemonicContainer';
import TutorialModal from './components/TutorialModal';
import ScanToDownloadModal from './components/ScanToDownloadModal';
import CreateWalletInput from './components/CreateWalletInput';
import CreateWalletInputFooter from './components/CreateWalletInputFooter';
import PageFooter from './components/PageFooter';
import PageTitle from './components/PageTitle';
import store from 'store';
import { Misc } from '@/helpers';
import IpadModal from '@/components/IpadModal';
import platform from 'platform';

export default {
  components: {
    'by-json-file-container': ByJsonFileContainer,
    'by-mnemonic-container': ByMnemonicContainer,
    'tutorial-modal': TutorialModal,
    'scan-to-download-modal': ScanToDownloadModal,
    'by-json-page-title': PageTitle,
    'create-wallet-input': CreateWalletInput,
    'create-wallet-input-footer': CreateWalletInputFooter,
    'by-json-page-footer': PageFooter,
    'ipad-modal': IpadModal
  },
  data() {
    return {
      byJson: false,
      byMnemonic: false,
      password: '',
      showProgressBar: false,
      canDownloadApple: true
    };
  },
  mounted() {
    this.canDownloadApple =
      platform.product !== null
        ? platform.product.toLowerCase() !== 'ipad'
        : true;
    const skipTutorial = store.get('skipTutorial');
    if (
      skipTutorial === undefined ||
      skipTutorial === null ||
      skipTutorial === false
    ) {
      this.$refs.tutorialModal.$refs.tutorial.show();
    }
  },
  methods: {
    switcher(by) {
      Misc.scrollToTop(1000);
      if (by === 'Json') {
        this.byJson = true;
        this.byMnemonic = false;
      } else if (by === 'Mnemonic') {
        this.byJson = false;
        this.byMnemonic = true;
      } else {
        this.byJson = false;
        this.byMnemonic = false;
      }
    },
    skip() {
      store.set('skipTutorial', true);
      this.$refs.tutorialModal.$refs.tutorial.hide();
    },
    scanToDownloadModalOpen() {
      this.$refs.scanToDownloadModal.$refs.scantodownload.show();
    },
    openIpadModal() {
      this.$refs.ipadModal.$refs.ipadModal.show();
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'CreateWalletLayout-desktop.scss';
@import 'CreateWalletLayout-tablet.scss';
@import 'CreateWalletLayout-mobile.scss';
</style>
